<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1100">
    <v-card>
      <v-card-title>
        <v-icon left color="primary">mdi-tag-multiple</v-icon>
        Preços dos produtos
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <v-simple-table>
          <thead>
            <tr>
              <th>Produto</th>
              <th class="text-right">Preço na venda</th>
              <th class="text-right">Preço atual</th>
              <th class="text-right">Variação</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, i) in rows"
              :key="i"
              :class="row.outdated ? 'amber lighten-4' : ''"
            >
              <td>
                <v-icon v-if="row.outdated" small color="warning" class="mr-1">mdi-alert</v-icon>
                {{ row.productName }}
              </td>
              <td class="text-right text-no-wrap">
                R$ {{ $format.decimal(row.savedPrice) }}
              </td>
              <td class="text-right text-no-wrap font-weight-bold" :class="row.outdated ? 'error--text' : ''">
                R$ {{ $format.decimal(row.currentPrice) }}
              </td>
              <td class="text-right text-no-wrap font-weight-bold" :class="row.diff > 0 ? 'success--text' : row.diff < 0 ? 'error--text' : ''">
                <template v-if="row.outdated">
                  <v-icon x-small :color="row.diff > 0 ? 'success' : 'error'">
                    {{ row.diff > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
                  </v-icon>
                  {{ row.diff > 0 ? '+' : '' }}R$ {{ $format.decimal(Math.abs(row.diff)) }}
                  ({{ row.diff > 0 ? '+' : '' }}{{ $format.decimal(row.diffPct) }}%)
                </template>
                <template v-else>—</template>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Fechar</v-btn>
        <!-- <v-btn color="primary" @click="$emit('update-prices'); $emit('input', false)">
          <v-icon left>mdi-refresh</v-icon>
          Atualizar Preços
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    saleProducts: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    rows() {
      return this.saleProducts.map((row, i) => {
        const currentPrice = row.product_variant.price_forward;
        const savedPrice = row.price;
        const outdatedRaw = currentPrice != savedPrice;
        const outdated =
          parseFloat(currentPrice).toFixed(2) !== parseFloat(savedPrice).toFixed(2);

        // console.group(`Produto [${i}] — ${row.product?.name ?? row.product_variant?.id}`);
        // console.log(`price_forward (atual)  : %c${currentPrice}%c (${typeof currentPrice})`, "font-weight:bold;color:#1976d2", "");
        // console.log(`price (salvo na venda) : %c${savedPrice}%c (${typeof savedPrice})`, "font-weight:bold;color:#1976d2", "");
        // console.log(`Desatualizado sem parseFloat : %c${outdatedRaw}`, outdatedRaw ? "color:red;font-weight:bold" : "color:green;font-weight:bold");
        // console.log(`Desatualizado com toFixed(2) : %c${outdated}`, outdated ? "color:red;font-weight:bold" : "color:green;font-weight:bold");
        // console.groupEnd();

        const diff = parseFloat((parseFloat(currentPrice) - parseFloat(savedPrice)).toFixed(2));
        const diffPct = parseFloat(savedPrice) !== 0
          ? parseFloat(((diff / parseFloat(savedPrice)) * 100).toFixed(2))
          : 0;

        return {
          productName: row.product?.name ?? `Variante #${row.product_variant?.id}`,
          currentPrice,
          savedPrice,
          outdatedRaw,
          outdated,
          diff,
          diffPct,
        };
      });
    },
  },
};
</script>
